// extracted by mini-css-extract-plugin
module.exports = {"item":"oblibene_item__bVsLu","cudo":"oblibene_cudo__SJa3o","title":"oblibene_title__3gRcO"};